// extracted by mini-css-extract-plugin
module.exports = {"Welcome":"WelcomeSection_Welcome__23aaJ","welcomeContent":"WelcomeSection_welcomeContent__3gjq0","logo":"WelcomeSection_logo__T-6Yj"};